/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  query SmsCountSentQuery($customerId: ID, $vendorId: ID, $endDate: DateTime!, $startDate: DateTime!) {
    SmsCountSent(customerId: $customerId, vendorId: $vendorId, endDate: $endDate, startDate: $startDate) {
      count,
      _totalCount,
      message,
      status
    }
  }
`

/*
 * EXPORTS
 */
export default Index
